export {
  SustainabilityPage as default,
  getStaticProps,
} from "@chef/feature-sanity/pages/sustainability";
